import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { Await, useSearchParams } from "react-router-dom";
import {
  IconArrowLeft,
  IconEdit,
  IconFileExport,
  IconFilter,
  IconPdf,
} from "@tabler/icons-react";
import Loading from "../../components/common/Loading";
import {
  DeductHalfDayFromAttendance,
  getAttendenceData,
  getCategorys,
  getDepartments,
  getDesignation,
  getEmpLeaveRequest,
  getEmployee,
  getemployeewithshift,
  GetLeavsAllemployesss,
  getProfitCenter,
  getPunchRecords,
  getShifEmployees,
  getShift,
  insertEditedInOut,
  insertMarkAttendence,
  insetNewAttendence,
  ProcessPunch,
  unautheriseatttendance,
} from "../../services/dataService";
import FilterComponent from "../pages/FilterComponent";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import zIndex from "@mui/material/styles/zIndex";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useRecoilState, useRecoilValue } from "recoil";
import { tempState } from "../../atom/atom";
import { data } from "jquery";
import { getSecureItem } from "../../services/SecureStorage";
import { DeductHalfdayStatus, DirectDeduct, endpoint } from "../../Config";
export default function Attendance({ formattedDate }) {
  const [searchParams] = useSearchParams();
  const dated = searchParams.get("date");
  const tempValue = useRecoilValue(tempState);
  const [statusFilter, setStatusFilter] = useState("all"); // "late", "notPunched", "punched", "approved", etc.
  const [filterMethod, setFilterMethod] = useState("");
  const [selectedOptionId, setSelectedOptionId] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [FilterName, SetFilterName] = useState("");
  // Add new state for time filter and time range
  const [LateDeductHalfday, setlateDeductHalfday] = useState("");
  const [isOverTimeModal,setisOverTimeModal]=useState(false)
  const [EmpOvertime, setEmpOvertime] = useState("");

  const [overtimeModalOpen, setOvertimeModalOpen] = useState(false);
const [rowBeingEdited, setRowBeingEdited] = useState(null);
const [tempOvertimeMinutes, setTempOvertimeMinutes] = useState(0);

  const [timeFilter, setTimeFilter] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const UID = getSecureItem("userId");
  const location = useLocation();
  const { state } = location || {};
  const { pending } = location.state || {};
  // Destructure state correctly

  // Access data from 'state'
  const [AttendenceRecords, setAttendenceRecords] = useState([]);
  const [date, setDate] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate());
    return yesterday.toISOString().split("T")[0];
  });
  const [loading, setLoading] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [shift, setShifs] = useState([]);
  const [filtervalue, setfiltervalue] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  // const [first, setfirst] = useState(second
  const [showDepName, setShowDepName] = useState("");
  // const DepartmentId = getSecureItem("DepartmentId");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepartmentId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const UserName = getSecureItem("UserName");
  const [employee, setEmployee] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [newInTime, setNewInTime] = useState("");
  const [newOutTime, setNewOutTime] = useState("");
  const [newshif, setnewshif] = useState("");
  const [temp, setTemp] = useRecoilState(tempState);
  const [newdep, setnewdep] = useState("");
  const navigate = useNavigate();
  const [paginationPerPage, setPaginationPerPage] = useState(50);
  const [paginationCurrentPage, setPaginationCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const handleDateChange = (e) => {
    // setLoading(false);
    setDate(e.target.value);
  };
  const [datafilter, setDataFilter] = useState([]);
  const [department, setDepartment] = useState([]);
  const [Departments, setDepartments] = useState([]);
  const [Designations, setDesignations] = useState([]);
  const [Categories, setCategory] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [newemp, setnewemp] = useState([]);
  const [AddAttedenceData, setAddAttedenceData] = useState({
    Id: "",
    EmpId: "",
    ATTENDANCESTATUS: 1,
    Date: "",
    Shift: "",
    EmployeeName: "",
    InTime: "",
    OutTime: "",
    DeptId: "",
  });
  const [PunchRecords, setPunchRecords] = useState([]);
  const [autheriseid, setautheriseid] = useState("");
  const [ProfitCenters, setProfitCenters] = useState([]);
  const [selectedpc, setselectedpc] = useState("");
  const [LeaveRequestData, setLeaveRequestData] = useState([]);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [employeerecord, setemployeerecord] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [addAttendenceModal, setAddAttendenceModal] = useState(false);
  const [filteredRows, setFilteredRows] = useState(
    datafilter?.filter((row) => {
      const rowData = [
        row.EmployeeName,
        row.EmpCode?.toString(), // Convert number to string
        row.ShiftName,
        row.DepartmentName,
        row.PunchIP,
        row.PUNCHIN,
        row.PUNCHOUT,
        row.ATTENDANCESTATUS === 1 ? "Approved" : "Pending",
        row.Punches,
      ];

      return rowData?.some((data) =>
        data?.toString().toLowerCase().includes(filterText.toLowerCase()),
      );
    }) || [], // Provide a default empty array if datafilter is undefined
  );
  const [moadaopen, setModalOpen] = useState(false);
  const [mobilePunch, setMobilePunch] = useState([]);
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
  const dd = String(currentDate.getDate()).padStart(2, "0");
  const today = `${yyyy}-${mm}-${dd}`;

  const handleEditClick = (rowId) => {
    const row = AttendenceRecords.find((record) => record.ID === rowId);
    if (row) {
      setEditingRow(row); // Set the current row being edited
      setNewInTime(row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "");
      setNewOutTime(row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "");
      setnewshif(row.SHIFTID);
      setnewdep(row.DEPARTMENTID);
      setnewemp(row.EMPLOYEEID);
      setShowModal(true); // Show the modal
    }
  };

  const fetchPunchRecords = async () => {
    const dates = {
      FromDate: date,
      ToDate: date,
    };
    try {
      setLoading(true);
      const result = await getPunchRecords(dates);
      setPunchRecords(result.data.data || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect(()=>{
  //  fetchPunchRecords()
  // },[date])

  const handleTimeFilterChange = (e) => {
    setTimeFilter(e.target.value);
    setTimeRange(""); // Reset time range when filter changes
  };

  // Update the time range dropdown handler
  const handleTimeRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  const timeToMinutes = (time) => {
    if (!time || time === "-") return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const exportToExcel = () => {
    // Group records by department (same as PDF)
    const recordsByDepartment = {};
    filteredRows?.forEach((row) => {
      const deptId = row.DEPARTMENTID;
      const deptName =
        department.find((el) => el.Id === deptId)?.Name || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    // Create workbook with one sheet per department
    const workbook = XLSX.utils.book_new();

    // Get the record date (formatted as dd/mm/yyyy)
    let recordDate = "N/A";
    if (AttendenceRecords.length > 0 && AttendenceRecords[0].RECORDDATE) {
      const date = new Date(AttendenceRecords[0].RECORDDATE);
      recordDate = date.toLocaleDateString("en-GB"); // Format as dd/mm/yyyy
    }

    // Process each department
    Object.entries(recordsByDepartment).forEach(([deptName, records]) => {
      const data = records.map((row, index) => {
        const punches = Array.isArray(row.punchPairs)
          ? row.punchPairs.flatMap((pair) => {
              const parts = [];

              if (pair.in) {
                const inDate = new Date(pair.in);
                const inHours = inDate
                  .getUTCHours()
                  .toString()
                  .padStart(2, "0");
                const inMinutes = inDate
                  .getUTCMinutes()
                  .toString()
                  .padStart(2, "0");
                parts.push(`${inHours}:${inMinutes} (in)`);
              }

              if (pair.out) {
                const outDate = new Date(pair.out);
                const outHours = outDate
                  .getUTCHours()
                  .toString()
                  .padStart(2, "0");
                const outMinutes = outDate
                  .getUTCMinutes()
                  .toString()
                  .padStart(2, "0");
                parts.push(`${outHours}:${outMinutes} (out)`);
              }

              return parts;
            })
          : ["No punches"];

        return {
          "Sl No": index + 1,
          "Employee Name": `${row.EmployeeName} - ${row.EmpCode}`,
          "In Time": formatEDTime(row.INTIME),
          "Out Time": formatEDTime(row.OUTTIME),
          "Shift Start": formatEDTime(row.StartTime),
          "Shift End": formatEDTime(row.EndTime),
          "Shift Name":
            shift.find((el) =>
              el.IsWeekly == 1 ? "Weekly Off" : el.Id === row.SHIFTID,
            )?.Name || "",
          "First In": formatEDTime(row.PUNCHIN),
          "Last Out": formatEDTime(row.PUNCHOUT),
          "Late Time": calculateLateTime(row),
          "Working Hours": row.WORKINGHOUR,
          Punches: punches.join(", "),
          Status: row.ATTENDANCESTATUS === 1 ? "APPROVED" : "PENDING",
        };
      });

      // Create a worksheet with headers first
      const recordDate = new Date(); // Replace with your actual date
      const formattedDate = recordDate.toLocaleDateString("en-GB"); // Format as dd/mm/yyyy

      const headerRows = [
        [`Department: ${deptName}`],
        [`Detailed Attendance Report - ${formattedDate} `],
        [], // Empty row for spacing
      ];

      // Create worksheet and add headers at the top
      const worksheet = XLSX.utils.aoa_to_sheet(headerRows);

      // Add the data below the headers
      XLSX.utils.sheet_add_json(worksheet, data, { origin: 3 });

      // Add the worksheet to the workbook
      const safeDeptName = deptName
        .replace(/[:\\/?*\[\]]/g, "_")
        .substring(0, 31);
      XLSX.utils.book_append_sheet(workbook, worksheet, safeDeptName);
    });

    // Add generation date to a new sheet
    const today = new Date();
    const infoSheet = XLSX.utils.aoa_to_sheet([
      ["Report Information"],
      ["Generated on:", today.toLocaleDateString("en-GB")], // Format as dd/mm/yyyy
      ["Total Departments:", Object.keys(recordsByDepartment).length],
      ["Total Employees:", AttendenceRecords.length],
    ]);
    XLSX.utils.book_append_sheet(workbook, infoSheet, "Report Info");
    const recorddDate = new Date(); // Replace with your actual date
    const formattedDate = recorddDate.toLocaleDateString("en-GB"); // Format as dd/mm/yyyy
    // Save the workbook
    XLSX.writeFile(
      workbook,
      `Detailed Attendance Report - ${formattedDate} .xlsx`,
    );
  };
  const exportToPDF = (FilterName) => {
    const subtitle =
      ProfitCenters.find((el) => el.Id == selectedpc)?.Name || "";
    const doc = new jsPDF("landscape");

    const tableColumn = [
      "Sl No",
      "Emp.Name-Emp.Code",
      "In Time",
      "Out Time",
      "Shift Start",
      "Shift End",
      "Shift Name",
      "First In",
      "Last Out",
      "Late Time",
      "Working Hours",
      "Punches",
      "Status",
    ];

    const recordsByDepartment = {};
    filteredRows?.forEach((row) => {
      const deptId = row.DEPARTMENTID;
      const deptName =
        department.find((el) => el.Id === deptId)?.Name || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    doc.setProperties({
      title: "Attendance Report",
      subject: "Attendance Report by Department",
      creator: "Attendance System",
    });

    let currentY = 20;

    let recordDate = "N/A";
    if (AttendenceRecords.length > 0 && AttendenceRecords[0].RECORDDATE) {
      const date = new Date(AttendenceRecords[0].RECORDDATE);
      recordDate = date.toLocaleDateString();
    }

    const addCenteredTitle = () => {
      const pageWidth = doc.internal.pageSize.width;
      const [month, day, year] = recordDate.split("/");
      const formattedDate = `${day}/${month}/${year}`;
      const title = `Detailed Attendance Report ${
        FilterName ? "" + FilterName : ""
      } ${
        tempValue ? "Of " + tempValue : ""
      } ON ${formattedDate}`.toUpperCase();
      const subHead = selectedpc ? `Profitcenter Name: ${subtitle}` : "";

      doc.setFontSize(16);
      const titleWidth = doc.getTextWidth(title);
      const xPos = (pageWidth - titleWidth) / 2;
      doc.text(title, xPos, 15);

      if (subHead) {
        doc.setFontSize(12);
        const subtitleWidth = doc.getTextWidth(subHead);
        const subtitleXPos = (pageWidth - subtitleWidth) / 2;
        doc.text(subHead, subtitleXPos, 25);
      }

      doc.setFontSize(12);
      return 35;
    };

    currentY = addCenteredTitle();

    const pageWidth = doc.internal.pageSize.width;
    const today = new Date();
    const totalPagesExp = "{total_pages_count_string}";

    Object.entries(recordsByDepartment).forEach(
      ([deptName, records], deptIndex) => {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(`Department: ${deptName}`, 14, currentY);
        doc.setFont(undefined, "normal");
        currentY += 5;

        const tableRows = records.map((row, index) => {
          const punches = Array.isArray(row.punchPairs)
            ? row.punchPairs.flatMap((pair) => {
                const parts = [];
                if (pair.in) {
                  const inDate = new Date(pair.in);
                  parts.push(
                    `${inDate
                      .getUTCHours()
                      .toString()
                      .padStart(2, "0")}:${inDate
                      .getUTCMinutes()
                      .toString()
                      .padStart(2, "0")} (in)`,
                  );
                }
                if (pair.out) {
                  const outDate = new Date(pair.out);
                  parts.push(
                    `${outDate
                      .getUTCHours()
                      .toString()
                      .padStart(2, "0")}:${outDate
                      .getUTCMinutes()
                      .toString()
                      .padStart(2, "0")} (out)`,
                  );
                }
                return parts;
              })
            : ["No punches"];

          return [
            index + 1,
            `${row.EmployeeName || ""} - ${row.EmpCode || ""}`,
            formatEDTime(row.INTIME),
            formatEDTime(row.OUTTIME),
            formatEDTime(row.StartTime),
            formatEDTime(row.EndTime),
            row.IsWeekly == 1
              ? "Weekly Off"
              : shift.find((el) => el.Id === row.SHIFTID)?.Name || "",

            (() => {
              const isPunchInDefault =
                row.PUNCHIN === "1900-01-01T00:00:00.000Z" ||
                row.PUNCHIN === null;
              return formatEDTime(isPunchInDefault ? null : row.PUNCHIN);
            })(),

            (() => {
              const isPunchOutDefault =
                row.PUNCHOUT === "1900-01-01T00:00:00.000Z" ||
                row.PUNCHOUT === null;
              return formatEDTime(isPunchOutDefault ? null : row.PUNCHOUT);
            })(),

            calculateLateTime(row),

            (() => {
              const decimalHour = parseFloat(row.WORKINGHOUR || 0);
              if (!decimalHour) return "-";
              const hours = Math.floor(decimalHour);
              const minutes = Math.floor((decimalHour - hours) * 60);
              return `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}`;
            })(),

            row.PUNCHIN && row.PUNCHOUT
              ? `${formatEDTime(row.PUNCHIN)} - ${formatEDTime(row.PUNCHOUT)}`
              : row.PUNCHIN
                ? `PUNCH IN: ${formatEDTime(row.PUNCHIN)}`
                : row.PUNCHOUT
                  ? `PUNCH OUT: ${formatEDTime(row.PUNCHOUT)}`
                  : "NO PUNCHES",

            (() => {
              const isPunchInDefault =
                row.PUNCHIN === "1900-01-01T00:00:00.000Z" ||
                row.PUNCHIN === null;
              const isPunchOutDefault =
                row.PUNCHOUT === "1900-01-01T00:00:00.000Z" ||
                row.PUNCHOUT === null;
              if (row.ATTENDANCESTATUS === 1) {
                if (isPunchInDefault && isPunchOutDefault)
                  return "APPROVED (NO PUNCHES)";
                if (isPunchInDefault && !isPunchOutDefault)
                  return "APPROVED (OUT ONLY)";
                if (!isPunchInDefault && isPunchOutDefault)
                  return "APPROVED (IN ONLY)";
                return "APPROVED";
              } else {
                if (isPunchInDefault && isPunchOutDefault)
                  return "PENDING (NO PUNCHES)";
                if (isPunchInDefault && !isPunchOutDefault)
                  return "PENDING (OUT ONLY)";
                if (!isPunchInDefault && isPunchOutDefault)
                  return "PENDING (IN ONLY)";
                return "PENDING";
              }
            })(),
          ];
        });

        doc.autoTable({
          startY: currentY,
          head: [tableColumn],
          body: tableRows,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          bodyStyles: {
            fillColor: [255, 255, 255],
          },
          margin: { top: 20, right: 14, bottom: 20, left: 14 },
          didDrawPage: function (data) {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            const pageNumber = doc.internal.getNumberOfPages();
            const footerText = `Generated on: ${today.toLocaleDateString()} | Page ${pageNumber} of ${totalPagesExp}`;

            doc.setFontSize(8);
            doc.text(
              footerText,
              pageWidth - doc.getTextWidth(footerText) - 14,
              pageHeight - 10,
            );
          },
        });

        currentY = doc.lastAutoTable.finalY + 10;
        if (
          deptIndex < Object.keys(recordsByDepartment).length - 1 &&
          currentY > doc.internal.pageSize.height - 40
        ) {
          doc.addPage();
          currentY = addCenteredTitle();
        }
      },
    );

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save("Detailed_Attendance_Report.pdf");
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "100",
    },
    content: {
      background: "white",
      padding: "20px",
      borderRadius: "8px",
      width: "400px",
      maxWidth: "100%",
    },
    inputField: {
      width: "100%",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      marginBottom: "10px",
    },
    button: {
      width: "48%",
      padding: "10px",
      borderRadius: "4px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    cancelButton: {
      backgroundColor: "#ccc",
      marginRight: "4%",
    },
    saveButton: {
      backgroundColor: "#28a745",
      color: "white",
    },
    cancelButtonHover: {
      backgroundColor: "#999",
    },
    saveButtonHover: {
      backgroundColor: "#218838",
    },
  };

  const handleButtonClick = (Id) => {
    setIsModalOpen(true); // Open the modal
    setautheriseid(Id);
  };

  const handleConfirm = () => {
    handleunautherise(autheriseid); // Call the unauthorize function
    setIsModalOpen(false); // Close the modal
  };

  const handleCancel = () => {
    setIsModalOpen(false); // Close the modal
    setautheriseid("");
  };
  const isAdmin = getSecureItem("IsAdmin");

  const Fetchleave = async (selectedDate) => {
    const attendanceData = {
      Date: selectedDate || date,
      UserId: UID,
      DepartmentId: selectedDepartment.value,
    };
    const response = await GetLeavsAllemployesss(attendanceData);
    const details =
      isAdmin == 1
        ? response?.data?.data
        : response?.data?.data?.filter((el) => el.DepartmentID == DepartmentId);

    setLeaveRequestData(details);
  };
  const fetchAttendenceRecords = async (selectedDate) => {
    try {
      const attendanceData = {
        Date: selectedDate || date,
        UserId: UID,
        DepartmentId: selectedDepartment.value,
      };

      const attendanceResponse = await getAttendenceData(attendanceData);
      setlateDeductHalfday(
        attendanceResponse.data.LateDeductHalfday,
      );

      let attendanceDetails =
        isAdmin == 1
          ? attendanceResponse?.data?.data
          : attendanceResponse?.data?.data?.filter(
              (el) => el?.DEPARTMENTID == DepartmentId,
            );

      if (attendanceDetails && attendanceDetails.length > 0) {
        const dateRange = {
          FromDate: selectedDate || date,
          ToDate: selectedDate || date,
        };

        const punchResponse = await getPunchRecords(dateRange);
        const allPunchRecords = punchResponse?.data?.data || [];

        const updatedAttendanceDetails = await Promise.all(
          attendanceDetails.map(async (record) => {
            
            let employeePunches = allPunchRecords.filter(
              (punch) =>
                punch.EMPLOYEEID === record.EMPLOYEEID && // ✅ Exact employee ID match
                punch.RECORDDATE === record.RECORDDATE, // ✅ Same record date
            );

            // Handle multi-day punches if needed
            if (record.PUNCHIN && record.PUNCHOUT) {
              const punchInDate = new Date(record.PUNCHIN)
                .toISOString()
                .split("T")[0];
              const punchOutDate = new Date(record.PUNCHOUT)
                .toISOString()
                .split("T")[0];

              if (punchInDate !== punchOutDate) {
                const multiDayRange = {
                  FromDate: punchInDate,
                  ToDate: punchOutDate,
                };

                const multiDayPunchResponse =
                  await getPunchRecords(multiDayRange);
                const multiDayPunches = multiDayPunchResponse?.data?.data || [];

                // ✅ Filter by EMPLOYEEID across the range
                const employeeMultiDayPunches = multiDayPunches.filter(
                  (punch) => punch.EMPLOYEEID === record.EMPLOYEEID,
                );

                // ✅ Group by RECORDDATE to avoid duplicates
                const groupedPunches = {};
                employeeMultiDayPunches.forEach((punch) => {
                  const punchDate = punch.RECORDDATE;
                  if (!groupedPunches[punchDate]) {
                    groupedPunches[punchDate] = [];
                  }
                  groupedPunches[punchDate].push(punch);
                });

                // ✅ Add punches from the main record date
                employeePunches = groupedPunches[record.RECORDDATE] || [];
              }
            }

            // ✅ Remove duplicates by ID
            employeePunches = [
              ...new Map(
                employeePunches.map((item) => [item.ID, item]),
              ).values(),
            ];

            const workingHoursData = getWorkingHoursData(employeePunches);

            return {
              ...record,
              CALCULATED_HOURS: parseFloat(workingHoursData.totalHours),
              WORKINGHOUR: parseFloat(workingHoursData.totalHours),
              BREAK_MINUTES: workingHoursData.totalBreak,
              punchPairs: workingHoursData.punchPairs,
              Punches: employeePunches
                .filter((punch) => punch.PUNCHIN || punch.PUNCHOUT) // ✅ Only valid punches
                .flatMap((p) => {
                  const punches = [];
                  if (p.PUNCHIN) {
                    const time = new Date(p.PUNCHIN).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "UTC",
                      },
                    );
                    punches.push(`${time} (in)`);
                  }
                  if (p.PUNCHOUT) {
                    const time = new Date(p.PUNCHOUT).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "UTC",
                      },
                    );
                    punches.push(`${time} (out)`);
                  }
                  return punches;
                })
                .join(", "),
            };
          }),
        );
                setTempOvertimeMinutes(calculateOvertimeMinutes(updatedAttendanceDetails));

        

        setAttendenceRecords(updatedAttendanceDetails);
      } else {
        setAttendenceRecords(attendanceDetails || []);
      }
    } catch (error) {
      console.error("Error fetching and processing attendance data", error);
      throw error;
    }
  };

  const handleOpenModal = async (row) => {
    setSelectedRow(row);

    const recordDateStr = row.RECORDDATE.split("T")[0]; // Date-only for comparison

    try {
      // Filter PunchRecords by EMPLOYEEID and RECORDDATE (date-only)
      let data = PunchRecords.filter(
        (el) =>
          el.EMPLOYEEID === row.EMPLOYEEID && // Strict EMPLOYEEID match
          el.RECORDDATE?.split("T")[0] === recordDateStr && // Date-only match
          (el.PUNCHIN || el.PUNCHOUT), // Exclude invalid punches
      );

      console.log(
        `Filtered punches for ${row.EmployeeName} (${row.EMPLOYEEID}):`,
        data,
      );

      // Remove duplicates by ID
      data = [...new Map(data.map((item) => [item.ID, item])).values()];
      console.log(
        `After deduplication, punches for ${row.EmployeeName}:`,
        data,
      );

      // Ensure only punches with valid times
      data = data.filter((punch) => punch.PUNCHIN || punch.PUNCHOUT);
      console.log(
        `Final valid punches for modal (${row.EmployeeName}):`,
        data.length,
        data,
      );

      setemployeerecord(data);
      handledone();
    } catch (error) {
      console.error(
        `Error processing punches for modal (${row.EmployeeName}):`,
        error,
      );
      setemployeerecord([]); // Clear modal data on error
      handledone();
    }
  };
  const handledone = () => {
    setIsModalOpen2(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen2(false);
  };
  const fetchProfitCenters = async () => {
    try {
      const response = await getProfitCenter(UID);

      setProfitCenters(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching profit centers:", error);
    }
  };

  const handleShowClick = async () => {
    setLoading(true);
    try {
      await fetchAttendenceRecords(date);
      await Fetchleave(date);
      await fetchPunchRecords(date);
      setselectedpc("");
    } catch (error) {
      console.error("Error in handleShowClick:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleApprove = async (e) => {
    console.log(tempOvertimeMinutes,'temp');
    
    e.preventDefault();
    setLoading(true);
    try {
      // Filter only the checked records (ATTENDANCESTATUS === 2)
      const checkedRecords = filteredRows.filter(
        (record) => record.ATTENDANCESTATUS === 2,
      );
      // Prepare the data with only checked records
      const data = {
        UserId: UID,
        AttendenceRecords: checkedRecords.map((record) => ({
          ...record,
          overtime:tempOvertimeMinutes,
          ID: record.ID == null ? "" : record.ID,
          ATTENDANCESTATUS: 1,
        })),
      };

      // Call the API with the filtered data
      const response = await insertMarkAttendence(data);
      if (response.data.data.StatusCode === 200) {
        if (LateDeductHalfday == "0") {
          const res = await DeductHalfDayFromAttendance(data);
        }
        toast.success("Records submitted successfully");
        fetchAttendenceRecords(date); // Refresh the records
        fetchPunchRecords();
        Fetchleave(date);
      }
    } catch (error) {
      console.error("Error approving attendance:", error);
      toast.error("Failed to approve attendance. Please try again.");
    } finally {
      setLoading(false);
      setEditingRowId(null);
    }
  };

  const formathour = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.floor((decimalHours - hours) * 60);
    const seconds = Math.floor(((decimalHours - hours) * 60 - minutes) * 60);

    return (
      `${hours.toString().padStart(2, "0")}:` +
      `${minutes.toString().padStart(2, "0")}:` +
      `${seconds.toString().padStart(2, "0")}`
    );
  };
  const formatBreakTime = (totalHours) => {
    if (!totalHours || isNaN(totalHours)) return "00:00:00";

    const hours = Math.floor(totalHours);
    const minutes = Math.floor((totalHours - hours) * 60);
    const seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

    return (
      `${hours.toString().padStart(2, "0")}:` +
      `${minutes.toString().padStart(2, "0")}:` +
      `${seconds.toString().padStart(2, "0")}`
    );
  };

  const handleunautherise = async (id) => {
    const data = {
      UserId: UID,
      Id: id,
    };

    const response = await unautheriseatttendance(data);
    if (response.data.data) {
      toast.success("Attendance Unautherised successfully ");
      fetchAttendenceRecords(date);
      fetchPunchRecords();
      Fetchleave(date);
    } else {
      // toast.error(err)
    }
  };

  const handleCancelEdit = () => {
    setShowModal(false); // Close the modal without saving
  };

  const handleModalYes = () => {
    setErrorModal(false);
    handleSelectAllPunchedChangeAfterYes({ target: { checked: true } });
  };

  const handleModalNo = () => {
    setErrorModal(false);
  };

  const handleSelectAllPunchedChangeAfterYes = (e) => {
    const checked = e.target.checked;
    setFilteredRows((prevRecords) =>
      prevRecords.map((record) => {
        const hasValidPunchIn =
          record.PUNCHIN && record.PUNCHIN !== "1900-01-01T00:00:00.000Z";
        const hasValidPunchOut =
          record.PUNCHOUT && record.PUNCHOUT !== "1900-01-01T00:00:00.000Z";

        // Common conditions
        const commonConditions =
          record.ATTENDANCESTATUS !== 1 &&
          record.SHIFTID &&
          record.LeaveStatus == 0 &&
          record.SHIFTID !== "00000000-0000-0000-0000-000000000000";

        // Punch validation based on StartTime and EndTime
        const punchValidation =
          record.StartTime === record.EndTime
            ? hasValidPunchIn || hasValidPunchOut // Either punch is valid
            : hasValidPunchIn && hasValidPunchOut; // Both punches required

        const isValid = punchValidation && commonConditions;

        return isValid
          ? { ...record, ATTENDANCESTATUS: checked ? 2 : 0 }
          : record;
      }),
    );
  };
  const handleSelectAllPunchedChange = (e) => {
    const checked = e.target.checked;

    const isAnyFilterEnabled =
      statusFilter !== "all" || filterMethod || filterText || selectedpc;

    // Check if we're trying to check the checkbox and filters are enabled
    if (checked && isAnyFilterEnabled) {
      setErrorModal(true);
      return;
    }
    // If unchecking or no filters are active, proceed directly
    handleSelectAllPunchedChangeAfterYes(e);
  };

  const getWorkingHoursData = (punchDetails) => {
    if (!punchDetails || punchDetails.length === 0) {
      return { punchPairs: [], totalHours: 0, totalBreak: 0 };
    }

    // Flatten all punch events and sort chronologically
    const events = [];
    punchDetails.forEach((record) => {
      if (record.PUNCHIN) {
        events.push({ time: new Date(record.PUNCHIN), type: "in" });
      }
      if (record.PUNCHOUT) {
        events.push({ time: new Date(record.PUNCHOUT), type: "out" });
      }
    });

    events.sort((a, b) => a.time - b.time);

    const punchPairs = [];
    let currentIn = null;
    let lastOut = null;
    let totalHours = 0;
    let totalBreak = 0;

    for (let i = 0; i < events.length; i++) {
      const event = events[i];

      if (event.type === "in") {
        if (currentIn) {
          // If there's an open in-punch, treat the previous in-punch as incomplete
          // and close it with the current in-punch (optional, depending on requirements)
          const duration = (event.time - currentIn) / (1000 * 60 * 60);
          punchPairs.push({
            in: currentIn,
            out: event.time,
            duration: duration.toFixed(2),
          });
          totalHours += parseFloat(duration.toFixed(2));
        }
        currentIn = event.time;
      } else if (event.type === "out" && currentIn) {
        // Close the current in-punch
        const duration = (event.time - currentIn) / (1000 * 60 * 60);
        punchPairs.push({
          in: currentIn,
          out: event.time,
          duration: duration.toFixed(2),
        });
        totalHours += parseFloat(duration.toFixed(2));
        lastOut = event.time;
        currentIn = null;

        // Calculate break time if there's a next punch-in
        if (i + 1 < events.length && events[i + 1].type === "in") {
          const nextInTime = events[i + 1].time;
          const breakDuration = (nextInTime - lastOut) / (1000 * 60 * 60); // Break time in hours
          totalBreak += parseFloat(breakDuration.toFixed(2));
        }
      }
    }

    return {
      punchPairs,
      totalHours: totalHours.toFixed(2),
      totalBreak: totalBreak.toFixed(2),
    };
  };

  const handleSaveTime = async () => {
    if (!newInTime || !newOutTime) return; // Ensure valid times are provided

    const convertToSpecial24HourFormat = (time) => {
      const [hourPart, minutePart] = time.split(":");
      let hour = parseInt(hourPart, 10);
      let minutes = minutePart ? parseInt(minutePart.slice(0, 2), 10) : 0;

      // Handle AM/PM if provided
      if (time.toLowerCase().includes("am")) {
        if (hour === 12) {
          return `24:${minutes.toString().padStart(2, "0")}`; // Convert midnight (12:00 AM) to 24:00
        }
      } else if (time.toLowerCase().includes("pm")) {
        if (hour !== 12) {
          hour += 12; // Convert PM times to 24-hour format
        }
      }

      return `${hour.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    };

    setAttendenceRecords((prevRecords) =>
      prevRecords.map((record) => {
        if (record.ID === editingRow.ID) {
          const inDatePart = record.INTIME.split("T")[0]; // Extract date part of InTime
          const outDatePart = record.OUTTIME.split("T")[0]; // Extract date part of OutTime

          // Convert to special 24-hour format
          const formattedInTime = convertToSpecial24HourFormat(newInTime);
          const formattedOutTime = convertToSpecial24HourFormat(newOutTime);

          return {
            ...record,
            INTIME: `${inDatePart}T${formattedInTime}:00.000Z`, // Combine date and new InTime
            OUTTIME: `${outDatePart}T${formattedOutTime}:00.000Z`, // Combine date and new OutTime
            SHIFTID: newshif,
            DEPARTMENTID: newdep,
          };
        }
        return record;
      }),
    );

    try {
      const formattedInTime = convertToSpecial24HourFormat(newInTime);
      const formattedOutTime = convertToSpecial24HourFormat(newOutTime);

      const updatedInOut = {
        UserId: UID,
        EmpId: editingRow.EMPLOYEEID || editingRow.EmpId, // Assuming this exists in editingRow
        OldInTime: editingRow.INTIME,
        UpdatedInTime: `${
          editingRow.INTIME.split("T")[0]
        }T${formattedInTime}:00.000Z`,
        OldOutTime: editingRow.OUTTIME,
        UpdatedOutTime: `${
          editingRow.OUTTIME.split("T")[0]
        }T${formattedOutTime}:00.000Z`,
        oldShiftId: newshif,
        UpdatedshiftId: `${editingRow.SHIFTID}`,
        UpdatedDepartmentId: `${editingRow.DEPARTMENTID}`,
        oldDepartmentId: newdep,
        UpdatedAt: new Date().toISOString(),
        UpdatedUserName: UserName,
        EmployeName: editingRow.EmployeeName,
        EmployeeCode: editingRow.EmpCode,
        PunchIN: editingRow.PUNCHIN,
        PunchOut: editingRow.PUNCHOUT,
        shiftRecordedDate: editingRow.RECORDDATE,
      };

      const response = await insertEditedInOut(updatedInOut);
    } catch (error) {
      console.error("Error updating in/out times:", error);
    }

    setShowModal(false); // Close the modal
    setNewInTime(""); // Clear the time input
    setNewOutTime(""); // Clear the time input
  };



  const isDefaultTime = (time) => {
    return (
      time === "1900-01-01T00:00:00.000Z" || time === null || time === undefined
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  function formatDateOnly(dateValue) {
    const date = new Date(dateValue);

    if (isNaN(date.getTime())) {
      // Invalid date, return a fallback or empty string
      return "";
    }

    return date.toISOString().split("T")[0]; // or whatever formatting you prefer
  }

  const filteredLeaveData = LeaveRequestData?.filter((item) => {
    const target = new Date(date);
    const from = new Date(item.FromDate);
    const to = new Date(item.ToDate);

    if (isNaN(from) || isNaN(to) || isNaN(target)) {
      console.warn(
        `Skipping due to invalid date(s): from=${from}, to=${to}, target=${target}`,
      );
      return false;
    }

    // Check if target date is within range (inclusive)
    return target >= from && target <= to;
  });

  const hasValidPunch = (row) => {
    return !isDefaultTime(row.PUNCHIN) || !isDefaultTime(row.PUNCHOUT);
  };

  const isAbsent = (row) => {
    return isDefaultTime(row.PUNCHIN) && isDefaultTime(row.PUNCHOUT);
  };

  

  const columnsFilter = [
    {
      cell: (row) => (
        console.log(row, "columsss"),
        (
          <div>
            <input
              type="checkbox"
              checked={row.ATTENDANCESTATUS === 2 || row.ATTENDANCESTATUS === 1}
              onChange={(e) => {
                setFilteredRows((prevRecords) =>
                  prevRecords.map((record) =>
                    record.EMPLOYEEID === row.EMPLOYEEID &&
                    record.SHIFTID === row.SHIFTID
                      ? {
                          ...record,
                          ATTENDANCESTATUS: e.target.checked ? 2 : 0,
                        }
                      : record,
                  ),
                );
              }}
              disabled={
                row.ATTENDANCESTATUS === 1 ||
                row.LeaveStatus == 1 ||
                !row.SHIFTID ||
                row.SHIFTID == "00000000-0000-0000-0000-000000000000"
              }
              style={{
                accentColor:
                  row.ATTENDANCESTATUS === 1
                    ? "green"
                    : row.ATTENDANCESTATUS === 2
                      ? "black"
                      : "gray",
                transform:
                  row.ATTENDANCESTATUS === 1 ? "scale(1.2)" : "scale(1)",
                cursor: row.ATTENDANCESTATUS === 1 ? "not-allowed" : "pointer",
              }}
            />
          </div>
        )
      ),
      grow: 0,
      width: "30px",
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3", color: "blue" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row),
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredRows?.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Employee Name",
      selector: (row) => `${row.EmployeeName} `,
      grow: 0,
      width: "190px",
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Code",
      selector: (row) => row.EmpCode,
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "In Time",
      selector: (row) => formatEDTime(row.INTIME),
      sortable: false,
      grow: 0,
      width: "90px",
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Out Time",
      selector: (row) => formatEDTime(row.OUTTIME),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: (
        <div>
          Shift
          <br />
          <span style={{ fontSize: "13px" }}>StartTime</span>
        </div>
      ),
      selector: (row) => formatEDTime(row.StartTime),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: (
        <div>
          Shift
          <br />
          <span style={{ fontSize: "13px" }}>EndTime</span>
        </div>
      ),
      selector: (row) => formatEDTime(row.EndTime),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "S_Name",
      selector: (row) => {
        if (row.IsWeekly === 1) {
          return "Weekly Off";
        }
        const shiftName = row.ShiftName;
        return shiftName || "";
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
      {
      name: "S_Name_B",
      width: "170px",
      selector: (row) => {
        const shiftName = row.ShiftBName
        return shiftName || "";
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",
          style: { backgroundColor: "#d3d3d3" },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    ...(state
      ? []
      : [
          {
            name: "Department",
            selector: (row) => {
              const Depname = department.find(
                (el) => el.Id === row.DEPARTMENTID,
              )?.Name;
              return Depname || "";
            },
            sortable: false,
            conditionalCellStyles: [
              {
                when: (row) =>
                  row.PunchIP == "1000" || row.IpAddressOut == "1000",

                style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
              },
              {
                when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
                style: {
                  backgroundColor: "#ff8863",
                  color: "green",
                  fontWeight: "bold",
                },
              },
              {
                when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#ff8863", color: "#000" },
              },
              {
                when: (row) =>
                  row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
                style: {
                  backgroundColor: "#f0fff0",
                  color: "green",
                  fontWeight: "bold",
                },
              },
              {
                when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#ffff99" },
              },
              {
                when: (row) =>
                  hasValidPunch(row) &&
                  !isLateArrival(row) &&
                  row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#add8e6" },
              },
            ],
          },
        ]),
    {
      name: "First In",
      selector: (row) => formatEDTime(row.PUNCHIN),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Last Out",
      selector: (row) => formatEDTime(row.PUNCHOUT),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Late Time",
      selector: (row) => calculateLateTime(row),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
{
  name: "Over Time",
  cell: (row) => {
    const manualMinutes = Number(row.overtimeMinutes ?? row.overtime ?? NaN);
    const hasManual = !isNaN(manualMinutes) && manualMinutes >= 0;

    const displayedMinutes = hasManual
      ? manualMinutes
      : calculateOvertimeMinutes(row);

    const isManual = hasManual;

    let displayText = "—";

    if (displayedMinutes > 0) {
      const h = Math.floor(displayedMinutes / 60);
      const m = displayedMinutes % 60;
      displayText = `${h}:${m.toString().padStart(2, "0")}`;
      if (isManual) displayText += "";
    }

    return (
      <button 
        disabled={row.ATTENDANCESTATUS==1}
        className={`px-3 py-1 text-xs bg-blue font-medium rounded min-w-[80px]`}
        onClick={() => handleOpenOvertimeModal(row)}
        title={isManual ? "Manually entered overtime" : "System calculated overtime"}
      >
        {displayText}
      </button>
    );
  },
  width: "120px",
  center: true,
},
    {
      name: "Early Out",
      selector: (row) => EarlyOut(row),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Punches",
      grow: 0,
      width: "150px",
      selector: (row) => {
        const punchArray = row?.Punches?.split(", ");
        const line1 = punchArray.slice(0, 2).join(", ");
        const line2 = punchArray.slice(2).join(", ");
        return (
          <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {line1}
            <br />
            {line2}
          </div>
        );
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",

          style: { backgroundColor: "#d3d3d3" }, // Gray background for PunchIP == 1000
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#ff8863",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => row.ATTENDANCESTATUS === 1 && !isLateArrival(row),
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: (
        <span>
          Working <span style={{ fontSize: "13px" }}>Hours</span>
        </span>
      ),
      selector: (row) => {
        const hoursValue = row.CALCULATED_HOURS || row.WORKINGHOUR || 0;
        const totalSeconds = Math.floor(hoursValue * 3600);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);

        const formattedTime = `${hours}:${minutes.toString().padStart(2, "0")}`;

        return (
          <div>
            <button
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleOpenModal(row);
              }}
              style={{
                color: row.ATTENDANCESTATUS === 1 ? "green" : undefined,
                fontWeight: row.ATTENDANCESTATUS === 1 ? "bold" : undefined,
              }}
            >
              <b>{formattedTime}</b>
            </button>
          </div>
        );
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: { backgroundColor: "#f0fff0" },
        },
      ],
    },
    {
      name: "A_Status",
      selector: (row) => {
        const isPunchInDefault = isDefaultTime(row.PUNCHIN);
        const isPunchOutDefault = isDefaultTime(row.PUNCHOUT);

        return row.ATTENDANCESTATUS === 1
          ? isPunchInDefault && isPunchOutDefault
            ? "APPROVED (No Punches)"
            : isPunchInDefault && !isPunchOutDefault
              ? "APPROVED (Out Only)"
              : !isPunchInDefault && isPunchOutDefault
                ? "APPROVED (In Only)"
                : "APPROVED"
          : isPunchInDefault && isPunchOutDefault
            ? "PENDING (No Punches)"
            : isPunchInDefault && !isPunchOutDefault
              ? "PENDING (Out Only)"
              : !isPunchInDefault && isPunchOutDefault
                ? "PENDING (In Only)"
                : "PENDING";
      },
      cell: (row) => {
        const isPunchInDefault = isDefaultTime(row.PUNCHIN);
        const isPunchOutDefault = isDefaultTime(row.PUNCHOUT);

        return (
          <span
            style={{
              color: row.ATTENDANCESTATUS === 1 ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {row.ATTENDANCESTATUS === 1
              ? isPunchInDefault && isPunchOutDefault
                ? "APPROVED (No Punches)"
                : isPunchInDefault && !isPunchOutDefault
                  ? "APPROVED (Out Only)"
                  : !isPunchInDefault && isPunchOutDefault
                    ? "APPROVED (In Only)"
                    : "APPROVED"
              : isPunchInDefault && isPunchOutDefault
                ? "PENDING (No Punches)"
                : isPunchInDefault && !isPunchOutDefault
                  ? "PENDING (Out Only)"
                  : !isPunchInDefault && isPunchOutDefault
                    ? "PENDING (In Only)"
                    : "PENDING"}
          </span>
        );
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: { backgroundColor: "#f0fff0" },
        },
      ],
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => handleEditClick(row.ID)}
            disabled={row.ATTENDANCESTATUS == 1 || isAdmin == 0}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          {row.ATTENDANCESTATUS == 1 && (
            <button
              className="bg-red-500 hover:bg-red-600 text-white rounded-[4px] flex w-24 items-center justify-center shadow-md transition duration-200 ease-in-out"
              onClick={() => handleButtonClick(row.ID)}
              style={{ color: "white" }}
            >
              Unauthorize
            </button>
          )}
        </div>
      ),
      conditionalCellStyles: [
        {
          when: (row) => row.PunchIP == "1000" || row.IpAddressOut == "1000",
          style: {
            backgroundColor: "#d3d3d3", // Gray background
          },
        },

        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: { backgroundColor: "#f0fff0" },
        },
      ],
    },
  ];

  const columnsFilterfor = [
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredRows?.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Employee Name",
      selector: (row) => `${row.EmployeeName} `,
      grow: 0,
      width: "190px",
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    {
      name: "Code",
      selector: (row) => row.EmpCode,
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },

    {
      name: (
        <div>
          Shift
          <br />
          <span style={{ fontSize: "13px" }}>StartTime</span>
        </div>
      ),
      selector: (row) => formatEDTime(row.StartTime),
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },

    {
      name: "S_Name",
      selector: (row) => {
        const shiftName = shift.find((el) => el.Id === row.SHIFTID)?.Name;
        return shiftName || "";
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: {
            backgroundColor: "#f0fff0",
            color: "green",
            fontWeight: "bold",
          },
        },
        {
          when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ff8863", color: "#000" },
        },
        {
          when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#ffff99" },
        },
        {
          when: (row) =>
            hasValidPunch(row) &&
            !isLateArrival(row) &&
            row.ATTENDANCESTATUS !== 1,
          style: { backgroundColor: "#add8e6" },
        },
      ],
    },
    ...(state
      ? []
      : [
          {
            name: "Department",
            selector: (row) => {
              const Depname = department.find(
                (el) => el.Id === row.DEPARTMENTID,
              )?.Name;
              return Depname || "";
            },
            sortable: false,
            conditionalCellStyles: [
              {
                when: (row) => row.ATTENDANCESTATUS === 1,
                style: {
                  backgroundColor: "#f0fff0",
                  color: "green",
                  fontWeight: "bold",
                },
              },
              {
                when: (row) => isLateArrival(row) && row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#ff8863", color: "#000" },
              },
              {
                when: (row) => isAbsent(row) && row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#ffff99" },
              },
              {
                when: (row) =>
                  hasValidPunch(row) &&
                  !isLateArrival(row) &&
                  row.ATTENDANCESTATUS !== 1,
                style: { backgroundColor: "#add8e6" },
              },
            ],
          },
        ]),

    {
      name: "A_Status",
      selector: (row) => {
        const isPunchInDefault = isDefaultTime(row.PUNCHIN);
        const isPunchOutDefault = isDefaultTime(row.PUNCHOUT);

        return row.ATTENDANCESTATUS === 1
          ? isPunchInDefault && isPunchOutDefault
            ? "APPROVED (No Punches)"
            : isPunchInDefault && !isPunchOutDefault
              ? "APPROVED (Out Only)"
              : !isPunchInDefault && isPunchOutDefault
                ? "APPROVED (In Only)"
                : "APPROVED"
          : isPunchInDefault && isPunchOutDefault
            ? "PENDING (No Punches)"
            : isPunchInDefault && !isPunchOutDefault
              ? "PENDING (Out Only)"
              : !isPunchInDefault && isPunchOutDefault
                ? "PENDING (In Only)"
                : "PENDING";
      },
      cell: (row) => {
        const isPunchInDefault = isDefaultTime(row.PUNCHIN);
        const isPunchOutDefault = isDefaultTime(row.PUNCHOUT);

        return (
          <span
            style={{
              color: row.ATTENDANCESTATUS === 1 ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {row.ATTENDANCESTATUS === 1
              ? isPunchInDefault && isPunchOutDefault
                ? "APPROVED (No Punches)"
                : isPunchInDefault && !isPunchOutDefault
                  ? "APPROVED (Out Only)"
                  : !isPunchInDefault && isPunchOutDefault
                    ? "APPROVED (In Only)"
                    : "APPROVED"
              : isPunchInDefault && isPunchOutDefault
                ? "PENDING (No Punches)"
                : isPunchInDefault && !isPunchOutDefault
                  ? "PENDING (Out Only)"
                  : !isPunchInDefault && isPunchOutDefault
                    ? "PENDING (In Only)"
                    : "PENDING"}
          </span>
        );
      },
      sortable: false,
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: { backgroundColor: "#f0fff0" },
        },
      ],
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => handleEditClick(row.ID)}
            disabled={row.ATTENDANCESTATUS == 1}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          {row.ATTENDANCESTATUS == 1 && (
            <button
              className="bg-red-500 hover:bg-red-600 text-white rounded-[4px] flex w-24 items-center justify-center shadow-md transition duration-200 ease-in-out"
              onClick={() => handleButtonClick(row.ID)}
              style={{ color: "white" }}
            >
              Unauthorize
            </button>
          )}
        </div>
      ),
      conditionalCellStyles: [
        {
          when: (row) => row.ATTENDANCESTATUS === 1,
          style: { backgroundColor: "#f0fff0" },
        },
      ],
    },
  ];

  const formatEDTime = (timeString) => {
    if (!timeString) return "-";

    const [datePart, timePart] = timeString.split("T");
    const year = datePart?.split("-")[0];
    const time = timePart?.slice(0, 5);

    if (time === "00:00" && year !== "1900") {
      return "24:00";
    }

    return time || "-";
  };

  const getTimeInMinutes = (dateString) => {
    if (!dateString) return 0;
    const date = new Date(dateString);
    return date.getUTCHours() * 60 + date.getUTCMinutes();
  };

  const isLateArrival = (row) => {
    if (!row.PUNCHIN || !row.StartTime || !row.RECORDDATE) return false;
    const gracePeriod = parseInt(row.GracePeriod) || 0; // Default 15 minutes grace period
    const punchInMinutes = getTimeInMinutes(row.PUNCHIN);
    const startTimeMinutes = getTimeInMinutes(row.StartTime);
    return punchInMinutes > startTimeMinutes + gracePeriod;
  };

  const calculateLateTime = (row) => {
    if (!row.PUNCHIN || !row.StartTime) return "-";
    const gracePeriod = parseInt(row.GracePeriod) || 0; // Default 15 minutes
    const punchInMinutes = getTimeInMinutes(row.PUNCHIN);
    const startTimeMinutes = getTimeInMinutes(row.StartTime);
    const allowedStartMinutes = startTimeMinutes + gracePeriod;
    if (punchInMinutes <= allowedStartMinutes) return "-";
    const lateMinutes = punchInMinutes - allowedStartMinutes;
    const hours = Math.floor(lateMinutes / 60);
    const minutes = lateMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  const calculateOverTime = (row) => {
    // ✅ Scheduled working time from ShiftWorkingHour
    let shiftWorkingHourStr;
    try {
      shiftWorkingHourStr = row.ShiftWorkingHour?.split("T")[1].split(".")[0];
    } catch (error) {
      return "-";
    }

    const convertTimeToMinutes = (timeStr) => {
      if (!timeStr || !timeStr.includes(":")) return 0;
      const [h, m, s] = timeStr.split(":").map((v) => parseInt(v) || 0);
      return h * 60 + m + Math.floor(s / 60);
    };

    const scheduledWorkingMinutes = convertTimeToMinutes(shiftWorkingHourStr);

    // ✅ Actual working time from CALCULATED_HOURS / WORKINGHOUR
    const hoursValue = row.CALCULATED_HOURS || row.WORKINGHOUR || 0;
    const totalMinutes = Math.floor(hoursValue * 60);

    // ✅ MinOverTime (convert from datetime string to minutes)
    let minOvertimeMinutes = 0;
    if (row.MinOverTime) {
      try {
        const minStr = row.MinOverTime.split("T")[1].split(".")[0]; // "00:00:00"
        minOvertimeMinutes = convertTimeToMinutes(minStr);
      } catch {
        minOvertimeMinutes = 0;
      }
    }

    // ✅ Overtime calculation
    const overtimeMinutes = totalMinutes - scheduledWorkingMinutes;
    
     setEmpOvertime(overtimeMinutes)
    if (overtimeMinutes > minOvertimeMinutes) {
      const hours = Math.floor(overtimeMinutes / 60);
      const minutes = overtimeMinutes % 60;
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    } else {
      return "-";
    }
  };

 const minutesToHhMm = (minutes) => {
  if (!minutes || minutes <= 0) return "—";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}:${m.toString().padStart(2, '0')}`;
};

const formatOvertimeDisplay = (minutes, isManual = false) => {
  if (!minutes || minutes <= 0) return "—";
  const display = minutesToHhMm(minutes);
  return isManual ? `${display} (man)` : display;
};

const formatOvertime = (minutes) => {
  if (!minutes || minutes <= 0) return "—";
  return minutesToHhMm(minutes);
};

  const EarlyOut = (row) => {
    if (
      !row.PUNCHOUT ||
      row.PUNCHOUT === "1900-01-01T00:00:00.000Z" ||
      !row.PUNCHIN ||
      row.PUNCHIN === "1900-01-01T00:00:00.000Z"
    ) {
      return "-";
    }

    const endTimeStr = row.EndTime?.split("T")[1].split(".")[0];
    const punchOutStr = row.PUNCHOUT?.split("T")[1].split(".")[0];

    if (!endTimeStr || !punchOutStr) {
      return "-";
    }

    const toMinutes = (timeStr) => {
      const [h, m, s] = timeStr.split(":").map(Number);
      return h * 60 + m;
    };

    const endMinutes = toMinutes(endTimeStr);
    const punchOutMinutes = toMinutes(punchOutStr);

    // Early Out = difference only if punchout < shift end
    if (punchOutMinutes < endMinutes) {
      const earlyOutMinutes = endMinutes - punchOutMinutes;
      const hours = Math.floor(earlyOutMinutes / 60);
      const minutes = earlyOutMinutes % 60;
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0",
      )}`;
    }

    return "-"; // No early out
  };


const calculateOvertimeMinutes = (row) => {
  if (!row) return 0;

  // Calculate actual minutes from PUNCHIN and PUNCHOUT difference
  let actual = 0;
  if (row.PUNCHIN && row.PUNCHOUT) {
    try {
      const inTime = new Date(row.PUNCHIN);
      const outTime = new Date(row.PUNCHOUT);
      actual = Math.round((outTime - inTime) / (1000 * 60)); // ms to minutes
    } catch {}
  }

  // Min working hour – parse time from date carrier
  let minWorking = 0;
  if (row.MinWorkingHour) {
    try {
      const t = row.MinWorkingHour.split("T")[1]?.split(".")[0] || "00:00:00";
      const [h, m] = t.split(":").map(Number);
      minWorking = (h || 0) * 60 + (m || 0);
    } catch {}
  }

  const potentialOT = actual - minWorking;

  return potentialOT > 0 ? potentialOT : 0;
};

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
    // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const fetchShifts = async () => {
    setLoading(true);
    try {
      const response = await getShift(UID); // Call the API
      setShifs(response.data.data); // Update state with fetched data
    } catch (error) {
      console.error("Error fetching shifts", error);
    } finally {
      setLoading(false);
    }
  };

  const timeRangeOptions = [
    { Id: "0-15", Name: "0-15 minutes" },
    { Id: "15-30", Name: "15-30 minutes" },
    { Id: "30-45", Name: "30-45 minutes" },
    { Id: "45-60", Name: "45-60 minutes" },
    { Id: ">60", Name: "More than 1 hour" },
  ];



  const handleopenModal = () => {
    setModalOpen(true);
  };

const handleOpenOvertimeModal = (row) => {
  setRowBeingEdited(row);
  const initialValue = calculateOvertimeMinutes(row);
  setTempOvertimeMinutes(initialValue);
  setOvertimeModalOpen(true);
};

const handleSaveOvertime = () => {
  if (!rowBeingEdited) return;

  const finalMinutes = tempOvertimeMinutes;

  // Update both filteredRows (visible table) and original data
  setFilteredRows(prev => 
    prev.map(r => 
      (r.ID && r.ID === rowBeingEdited.ID) ||
      (r.EMPLOYEEID === rowBeingEdited.EMPLOYEEID && r.RECORDDATE === rowBeingEdited.RECORDDATE)
        ? { ...r, overtimeMinutes: finalMinutes }
        : r
    )
  );

  setAttendenceRecords(prev => 
    prev.map(r => 
      (r.ID && r.ID === rowBeingEdited.ID) ||
      (r.EMPLOYEEID === rowBeingEdited.EMPLOYEEID && r.RECORDDATE === rowBeingEdited.RECORDDATE)
        ? { ...r, overtimeMinutes: finalMinutes }
        : r
    )
  );

  toast.success(`Overtime updated for ${rowBeingEdited.EmployeeName}`);
  setOvertimeModalOpen(false);
  setRowBeingEdited(null);
};

  const Modalback = () => {
    setModalOpen(false);
  };

  const handleFilterMobilePunch = (e) => {
    if (e.target.checked) {
      const filtered = filteredRows.filter(
        (el) => el.PunchIP == 1000 || el.IpAddressOut == 1000,
      );
      setMobilePunch(filtered);
      setDataFilter(filtered); // ✅ use local variable
    } else {
      setMobilePunch([]);
      setDataFilter(AttendenceRecords); // ✅ reset to full list
    }
  };

  useEffect(() => {
    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate());
    const formattedDate = yesterday.toISOString().split("T")[0];

    // Set yesterday's date as default
    setDate(formattedDate);

    // If there's a state date (from navigation), use that instead
    if (state?.date) {
      setDate(state.date);
    }
  }, [state]);

  useEffect(() => {
    if (datafilter) {
      const filtered = datafilter?.filter((row) => {
        // Text-based filter
        const rowData = [
          row.EmployeeName?.toLowerCase(),
          row.EmpCode?.toString().toLowerCase(),
          shift.find((el) => el.Id === row.SHIFTID)?.Name?.toLowerCase(),
          department
            .find((el) => el.Id === row.DEPARTMENTID)
            ?.Name?.toLowerCase(),
          row.ATTENDANCESTATUS === 1 ? "approved" : "pending",
          row.Punches?.toLowerCase(),
        ].filter(Boolean);

        const textMatch = rowData.some((data) =>
          data.includes(filterText.toLowerCase()),
        );

        // Color-based filter
        let statusMatch = true;
        if (statusFilter === "approved") {
          statusMatch = row.ATTENDANCESTATUS === 1;
        } else if (statusFilter === "late") {
          statusMatch = isLateArrival(row);
        } else if (statusFilter === "notPunched") {
          statusMatch = isAbsent(row);
        } else if (statusFilter === "zz") {
          statusMatch = hasValidPunch(row);
        }

        // Additional filters (department, profit center)
        const departmentMatches = state?.DEPARTMENTID
          ? row?.DEPARTMENTID === state?.DEPARTMENTID
          : true;
        const profitCenterMatches = selectedpc
          ? row?.ProfitCenterID === selectedpc
          : true;

        return (
          textMatch && statusMatch && departmentMatches && profitCenterMatches
        );
      });
      setFilteredRows(filtered);
    }
  }, [
    filterText,
    datafilter,
    resetPaginationToggle,
    shift,
    department,
    statusFilter,
    state,
    selectedpc,
  ]);

  useEffect(() => {
    setDataFilter(AttendenceRecords);
  }, [AttendenceRecords]);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        // setDepartment(response);

        setDepartments(response?.data?.data);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    const fetchDesignations = async () => {
      try {
        const data = await getDesignation(UID);
        setDesignations(data.data.data);
        setIsFilterVisible(false);
      } catch (error) {
        console.error("Error fetching designations", error);
      }
      setLoading(false);
    };
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);

        setCategory(response?.data?.data);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchcategory();
    fetchDepartment();
    fetchDesignations();
  }, []);

  useEffect(() => {
    // Check if all rows have ATTENDANCESTATUS = 1
    const allApproved = AttendenceRecords.every(
      (row) => row.ATTENDANCESTATUS === 1,
    );
    setIsAllSelected(allApproved); // If all have ATTENDANCESTATUS = 1, set "Select All" as checked
  }, [AttendenceRecords]);
  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const responses = await getDepartments(UID);
        setDepartment(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchProfitCenters();
  }, []);

  useEffect(() => {
    const fetchAllemployee = async () => {
      const empdata = {
        UserId: UID,
        Date: new Date(),
      };
      try {
        const responses = await getShifEmployees(empdata);
        setEmployee(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchAllemployee();
  }, [UID, AddAttedenceData.Date]); // Add dependencies if needed (e.g., UID or AddAttedenceData.date)

  useEffect(() => {
    const departmentname = department?.find(
      (el) => el.Id === DepartmentId,
    )?.Name;
    setShowDepName(departmentname || "");
  }, [department]);

  useEffect(() => {}, [showDepName]);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
    setDate(currentDate);
  }, []);

  useEffect(() => {
    fetchAttendenceRecords(state?.date);
    Fetchleave(state?.date);
    fetchProfitCenters();
    fetchPunchRecords();
  }, [state]);

  useEffect(() => {
    setFilteredRows(datafilter);
  }, [datafilter]);

  useEffect(() => {
    if (datafilter) {
      const filtered = datafilter?.filter((row) => {
        // Text-based filter
        const rowData = [
          row.EmployeeName?.toLowerCase(),
          row.EmpCode?.toString().toLowerCase(),
          shift.find((el) => el.Id === row.SHIFTID)?.Name?.toLowerCase(),
          department
            .find((el) => el.Id === row.DEPARTMENTID)
            ?.Name?.toLowerCase(),
          row.ATTENDANCESTATUS === 1 ? "approved" : "pending",
          row.Punches?.toLowerCase(),
        ].filter(Boolean);

        const textMatch = rowData.some((data) =>
          data.includes(filterText.toLowerCase()),
        );

        // Status-based filter
        let statusMatch = true;
        if (statusFilter === "approved") {
          statusMatch = row.ATTENDANCESTATUS === 1;
        } else if (statusFilter === "late") {
          statusMatch = isLateArrival(row);
        } else if (statusFilter === "notPunched") {
          statusMatch = isAbsent(row);
        } else if (statusFilter === "punched") {
          statusMatch = hasValidPunch(row);
        }

        // Department and Profit Center filters
        const departmentMatches = state?.DEPARTMENTID
          ? row?.DEPARTMENTID === state?.DEPARTMENTID
          : true;
        const profitCenterMatches = selectedpc
          ? row?.ProfitCenterID === selectedpc
          : true;

        // Time-based filter
        let timeMatch = true;
        if (timeFilter && timeRange) {
          let timeValue;
          if (timeFilter === "late") {
            timeValue = timeToMinutes(calculateLateTime(row));
          } else if (timeFilter === "over") {
            timeValue = timeToMinutes(calculateOverTime(row));
          } else if (timeFilter === "early") {
            timeValue = timeToMinutes(EarlyOut(row));
          }

          const [min, max] = timeRange.split("-").map(Number);
          if (timeRange === ">60") {
            timeMatch = timeValue > 60;
          } else {
            timeMatch = timeValue >= min && (max ? timeValue <= max : true);
          }
        }

        return (
          textMatch &&
          statusMatch &&
          departmentMatches &&
          profitCenterMatches &&
          timeMatch
        );
      });
      setFilteredRows(filtered);
    }
  }, [
    filterText,
    datafilter,
    resetPaginationToggle,
    shift,
    department,
    statusFilter,
    state,
    selectedpc,
    timeFilter,
    timeRange,
  ]);

  useEffect(() => {
    setfiltervalue(tempValue);
  }, [tempValue]);

  useEffect(() => {}, [filtervalue]);

  useEffect(() => {
    if (state) {
      setDate(state.date);
    }
  }, [state]);

  useEffect(() => {
    fetchShifts();
  }, []);

  return (
    <>
      {moadaopen && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="p-8 rounded-xl shadow-xl bg-white w-[700px] max-h-[550px] flex flex-col">
            <div className="flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Color Codes
              </h2>
            </div>
            <div className="flex-grow overflow-y-auto max-h-[450px] pr-4">
              <div className="space-y-4">
                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#ff8863] mr-4"></div>
                  <div>
                    <p className="font-medium">Late employees</p>
                    <p className="text-sm text-gray-500">
                      Employees who arrived after the Shift start time
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#ffff99] mr-4"></div>
                  <div>
                    <p className="font-medium">Not Punched employees</p>
                    {/* <p className="text-sm text-gray-500">Employees who have not yet Punched </p> */}
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#add8e6] mr-4"></div>
                  <div>
                    <p className="font-medium">Punched employees</p>
                    {/* <p className="text-sm text-gray-500">Employees punched</p> */}
                  </div>
                </div>
                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#d3d3d3] mr-4"></div>
                  <div>
                    <p className="font-medium">Mobile Punch </p>
                    {/* <p className="text-sm text-gray-500">Employees punched</p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                onClick={Modalback}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-8">
        <div>
          {/* <p className="ms-5">User Department is : {showDepName}</p> */}
          <div className="flex items-center justify-between gap-4 mb-6">
            <Breadcrumb title="Detailed Attendance" />
            <div className="px-4 py-2 bg-blue-50 text-blue-800 rounded-md border border-blue-200 text-sm mt-3">
              <p style={{ fontSize: "15px" }}>
                <span style={{ color: "red", fontWeight: "bold" }}>Note:</span>{" "}
                On this detailed attendance page, you can only approve
                attendance for previous dates, not current or future dates.
              </p>

              <p
                style={{
                  fontSize: "15px",
                  marginTop: "6px",
                  fontWeight: LateDeductHalfday == 0 ? "bold" : "normal",
                  color: LateDeductHalfday == 0 ? "red" : "green",
                }}
              >
                {LateDeductHalfday == 0
                  ? "Direct Late Deduct Half-Day is Enabled"
                  : "Direct Late Deduct Half-Day is Disabled"}
              </p>
            </div>
          </div>{" "}
          {state && <h3>{state.DepartmentId}</h3>}
        </div>
        {/* Action Area */}
        {AttendenceRecords.length > 0 ? (
          <div className="flex items-center gap-4">
            {/* Search and Clear Buttons */}
            <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
              <button
                className="bg-sky rounded-[4px] px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="relative">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by EmpName/code/Dep/shift/Status"
                  className="w-[350px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button onClick={handleClear} className="btn btn-danger">
                Clear
              </button>
            </div>
            {/* <div className="selection-count">
              Selected {filteredRows.filter(r => r.ATTENDANCESTATUS === 2).length} of {filteredRows.length} visible items
            </div> */}

            {/* Add New Button */}
          </div>
        ) : (
          ""
        )}
      </div>
      {showModal && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.content}>
            <div className="flex flex-col gap-4 ">
              <div>
                <label htmlFor="inTime">In Time:</label>
                <input
                  id="inTime"
                  type="time"
                  value={newInTime === "24:00" ? "00:00" : newInTime} // Convert 24:00 to 00:00 for display
                  onChange={(e) => {
                    const value = e.target.value;
                    setNewInTime(value === "00:00" ? "24:00" : value); // Convert 00:00 to 24:00 if applicable
                  }}
                  style={modalStyles.inputField}
                />
              </div>

              <div>
                <label htmlFor="outTime">Out Time:</label>
                <input
                  id="outTime"
                  type="time"
                  value={newOutTime === "24:00" ? "00:00" : newOutTime} // Convert 24:00 to 00:00 for display
                  onChange={(e) => {
                    const value = e.target.value;
                    setNewOutTime(value === "00:00" ? "24:00" : value); // Convert 00:00 to 24:00 if applicable
                  }}
                  style={modalStyles.inputField}
                />
              </div>

              <div className="form-group flex col-span-12 flex-col">
                <label>Shift</label>
                <select
                  id="shift"
                  name="Shift"
                  value={newshif}
                  onChange={(e) => setnewshif(e.target.value)}
                >
                  <option value="">Select Shift</option>
                  {shift.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group flex col-span-12 flex-col mb-2">
                <label>
                  Department <span style={{ color: "red" }}></span>
                </label>
                <select
                  id="Department"
                  name="Department"
                  disabled
                  value={newdep}
                  onChange={(e) => setnewdep(e.target.value)}
                >
                  <option value="">Select Department</option>
                  {department.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div
              className="modal-actions"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                style={{
                  ...modalStyles.button,
                  ...modalStyles.saveButton,
                }}
                onClick={handleSaveTime}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor =
                    modalStyles.saveButtonHover.backgroundColor)
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor =
                    modalStyles.saveButton.backgroundColor)
                }
              >
                Save
              </button>
              <button
                style={{
                  ...modalStyles.button,
                  ...modalStyles.cancelButton,
                }}
                onClick={handleCancelEdit}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor =
                    modalStyles.cancelButtonHover.backgroundColor)
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor =
                    modalStyles.cancelButton.backgroundColor)
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilterfor}
          data={
            state?.DEPARTMENTID
              ? AttendenceRecords?.filter(
                  (el) => el?.DEPARTMENTID === state?.DEPARTMENTID,
                )
              : AttendenceRecords
          }
          onFilter={handleFilter}
          temp={temp}
          setTemp={setTemp}
        />
      )}
  {overtimeModalOpen && rowBeingEdited && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-2xl">
      <h3 className="text-lg font-bold mb-4">
        Edit Overtime — {rowBeingEdited.EmployeeName}
      </h3>

      <div className="mb-5">
        <label className="block text-sm font-medium mb-1.5">
          Overtime (HH:MM)
        </label>
        <input
          type="text"
          className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-blue-500"
          placeholder="1:45"
          value={minutesToHhMm(tempOvertimeMinutes)}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9:]/g, '');
            if (!val) {
              setTempOvertimeMinutes(0);
              return;
            }
            const [h = 0, m = 0] = val.split(':').map(Number);
            if (m > 59) return;
            setTempOvertimeMinutes(h * 60 + m);
          }}
        />
      </div>

      <div className="flex justify-end gap-3">
        <button
          className="px-5 py-2 bg-gray-200 hover:bg-gray-300 rounded"
          onClick={() => setOvertimeModalOpen(false)}
        >
          Cancel
        </button>
        <button
          className="px-5 py-2 bg-blue hover:bg-blue text-white rounded"
          onClick={handleSaveOvertime}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}

      {isModalOpen2 && selectedRow && (
        <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-2xl">
            <h2 className="text-xl font-bold mb-4">Working Hour Details</h2>
            {(() => {
              const { punchPairs, totalHours, totalBreak } =
                getWorkingHoursData(employeerecord);
              return (
                <>
                  <div className="flex justify-between mb-2 text-sm">
                    <p>
                      <strong>Total Working Hours:</strong>{" "}
                      {formathour(totalHours)}
                    </p>
                    <p>
                      <strong>Total Break Time:</strong>{" "}
                      {formatBreakTime(totalBreak)}
                    </p>
                  </div>
                  {punchPairs.length > 0 ? (
                    <table className="w-full border mt-4 text-sm">
                      <thead>
                        <tr>
                          <th className="border px-2 py-1">Punch In</th>
                          <th className="border px-2 py-1">Punch Out</th>
                          <th className="border px-2 py-1">Duration (hrs)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {punchPairs.map((pair, index) => (
                          <tr key={index}>
                            <td className="border px-2 py-1">
                              {pair.in
                                ? pair.in
                                    .toISOString()
                                    .split("T")[1]
                                    .slice(0, 5)
                                : "-"}
                            </td>
                            <td className="border px-2 py-1">
                              {pair.out
                                ? pair.out
                                    .toISOString()
                                    .split("T")[1]
                                    .slice(0, 5)
                                : "-"}
                            </td>
                            <td className="border px-2 py-1">
                              {formathour(pair?.duration)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No punch data available for this employee.</p>
                  )}
                </>
              );
            })()}
            <div className="flex justify-end mt-4">
              <button
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={handleCloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="flex flex-wrap items-center justify-evenly w-full gap-6 p-4">
          {/* Date Input and Show Button */}
          <div className="flex items-center gap-6">
            <div>
              <label
                htmlFor="date-input"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Select Date
              </label>
              <input
                type="date"
                id="date-input"
                className="w-[180px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                value={date}
                onChange={handleDateChange}
              />
            </div>
            <button
              className="btn btn-success h-[38px] mt-[22px]"
              onClick={handleShowClick}
            >
              Show
            </button>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center mt-4 gap-6">
            <button
              onClick={exportToExcel}
              className="bg-green-500  text-white px-4 py-2 rounded h-[38px]"
            >
              Export EXCEL
            </button>
            <button
              onClick={() => exportToPDF(FilterName)}
              className="bg-red-500 text-white px-4 py-2 rounded h-[38px]"
            >
              Download PDF
            </button>
            <button
              onClick={handleopenModal}
              className="btn btn-primary h-[38px]"
            >
              Color Code Info
            </button>
          </div>

          {/* Color Filter Dropdown */}
          <div className="w-[180px]">
            <label
              htmlFor="statusFilter"
              className="block text-sm font-medium text-gray-700"
            >
              Filter by Color
            </label>
            <select
              id="statusFilter"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="block w-full h-[38px] border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="all">All</option>
              <option value="late">Late</option>
              <option value="notPunched">Not Punched</option>
              <option value="punched">Punched</option>
            </select>
          </div>

          {/* Admin Filters */}
          {isAdmin == 1 && (
            <div className="flex items-center gap-6 mt-4">
              <select
                id="filter-method"
                name="filter-method"
                className="px-3 py-2 h-[38px] border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-[150px]"
                value={filterMethod}
                onChange={(e) => {
                  const selected = e.target.value;
                  setFilterMethod(selected);
                  setSelectedOptionId("");
                  if (selected === "ProfitCenterID")
                    setDropdownOptions(ProfitCenters);
                  else if (selected === "DepartmentID")
                    setDropdownOptions(Departments);
                  else if (selected === "DesignationId")
                    setDropdownOptions(Designations);
                  else if (selected === "CategoryId")
                    setDropdownOptions(Categories);
                  else setDropdownOptions([]);
                }}
              >
                <option value="">Filter By</option>
                <option value="ProfitCenterID">Profit Center</option>
                <option value="DepartmentID">Department</option>
                <option value="DesignationId">Designation</option>
                <option value="CategoryId">Category</option>
              </select>

              <select
                id="dynamic-options"
                name="dynamic-options"
                className="px-3 py-2 h-[38px] border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-[150px]"
                value={selectedOptionId}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setSelectedOptionId(selectedId);
                  const filtered = AttendenceRecords?.filter(
                    (record) => record[filterMethod] == selectedId,
                  );
                  setDataFilter(filtered);
                }}
                disabled={!filterMethod}
              >
                <option value="">Choose One</option>
                {dropdownOptions.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.Name}
                  </option>
                ))}
              </select>

              <select
                id="time-filter"
                name="time-filter"
                className="px-3 py-2 h-[38px] border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-[150px]"
                value={timeFilter}
                onChange={handleTimeFilterChange}
              >
                <option value="">Filter By Time</option>
                <option value="over">Overtime</option>
                <option value="late">Late Time</option>
                <option value="early">Early Out</option>
              </select>

              <select
                id="time-range"
                name="time-range"
                className="px-3 py-2 h-[38px] border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-[150px]"
                value={timeRange}
                onChange={handleTimeRangeChange}
                disabled={!timeFilter}
              >
                <option value="">Choose Range</option>
                {timeRangeOptions.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.Name}
                  </option>
                ))}
              </select>

              <button
                className="btn btn-danger h-[38px]"
                onClick={() => {
                  setFilterMethod("");
                  setSelectedOptionId("");
                  setDropdownOptions([]);
                  setDataFilter(AttendenceRecords);
                  setStatusFilter("");
                  setTimeFilter("");
                  setTimeRange("");
                }}
              >
                Clear
              </button>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="h-[35px] w-[35px]"
                  onChange={handleFilterMobilePunch}
                />
                Show Mobile Punches
              </label>
            </div>
          )}
        </div>

        {errorModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-md z-[9999] animate-in fade-in duration-300">
            <div className="bg-white p-8 rounded-2xl shadow-2xl border border-gray-100 text-center max-w-md w-full mx-4 transform transition-all duration-300 scale-100 hover:scale-[1.02]">
              <div className="mb-6">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-amber-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Confirm Action
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {/* Table data have <span className="font-semibold text-gray-900">{filteredRows.length}</span> items. */}
                  {filteredRows.length > 1
                    ? " Filters are currently enabled."
                    : ""}
                </p>
                <p className="text-gray-700 font-medium mt-2">
                  Do you want to proceed to approve?
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleModalYes}
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-medium py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-green-200"
                >
                  Yes, Approve
                </button>
                <button
                  onClick={handleModalNo}
                  className="flex-1 bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-700 font-medium py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {/**conditionally show Back Button */}
        {!state ? (
          <div className="flex"></div>
        ) : (
          <div className="w-full flex items-center justify-between text-3xl mt-2">
            {/* Back Icon on the left */}
            <div className="flex items-center">
              <IconArrowLeft
                style={{ cursor: "pointer", color: "red" }}
                size={30}
                onClick={() => navigate(-1)}
              />
            </div>

            <div className="text-center flex-1">{state.DepartmentName}</div>
          </div>
        )}

        {AttendenceRecords?.length == 0 ? (
          ""
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            <input
              type="checkbox"
              onChange={handleSelectAllPunchedChange}
              checked={(() => {
                const punchedRecords = filteredRows.filter((record) => {
                  const hasValidPunchIn =
                    record.PUNCHIN &&
                    record.PUNCHIN !== "1900-01-01T00:00:00.000Z";
                  const hasValidPunchOut =
                    record.PUNCHOUT &&
                    record.PUNCHOUT !== "1900-01-01T00:00:00.000Z";

                  // Common conditions
                  const commonConditions =
                    record.ATTENDANCESTATUS !== 1 &&
                    record.SHIFTID &&
                    record.LeaveStatus == 0 &&
                    record.SHIFTID !== "00000000-0000-0000-0000-000000000000";

                  // Punch validation based on StartTime and EndTime
                  const punchValidation =
                    record.StartTime === record.EndTime
                      ? hasValidPunchIn || hasValidPunchOut // Either punch is valid
                      : hasValidPunchIn && hasValidPunchOut; // Both punches required

                  return punchValidation && commonConditions;
                });

                return (
                  punchedRecords.length > 0 &&
                  punchedRecords.every(
                    (record) => record.ATTENDANCESTATUS === 2,
                  )
                );
              })()}
            />
            <label htmlFor="">Select All Punched</label>
          </div>
        )}

        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <>
              <ReactDataTable
                columns={columnsFilter}
                data={filteredRows?.filter((el) => {
                  // Filter by department
                  const departmentMatches = state?.DEPARTMENTID
                    ? el?.DEPARTMENTID === state?.DEPARTMENTID
                    : true;

                  // Filter by profit center
                  const profitCenterMatches = selectedpc
                    ? el?.ProfitCenterID === selectedpc
                    : true;

                  // Filter by attendance status
                  const statusMatch = (() => {
                    switch (statusFilter) {
                      case "approved":
                        return el.ATTENDANCESTATUS === 1;
                      case "late":
                        return isLateArrival(el);
                      case "notPunched":
                        return isAbsent(el);
                      case "punched":
                        return hasValidPunch(el);
                      default:
                        return true;
                    }
                  })();

                  return (
                    departmentMatches && profitCenterMatches && statusMatch
                  );
                })}
                pagination
                paginationPerPage={paginationPerPage}
                paginationDefaultPage={paginationCurrentPage}
                onChangeRowsPerPage={(currentRowsPerPage) => {
                  setPaginationPerPage(currentRowsPerPage);
                }}
                onChangePage={(page) => {
                  setPaginationCurrentPage(page);
                }}
              />

              {/* Leave Requests Table */}
              <ReactDataTable
                columns={[
                  { name: "Name", selector: (row) => row.Name, sortable: true },
                  {
                    name: "Leave Type",
                    selector: (row) => row.LeaveTypeName,
                    sortable: true,
                  },
                  {
                    name: "From",
                    selector: (row) => formatDate(row.FromDate),
                    sortable: true,
                  },
                  {
                    name: "To",
                    selector: (row) => formatDate(row.ToDate),
                    sortable: true,
                  },
                  {
                    name: "Days",
                    selector: (row) => row.NoOfDays,
                    sortable: true,
                  },
                  {
                    name: "Department",
                    selector: (row) => row.DepartmentName,
                    sortable: true,
                  },
                  {
                    name: "Reason",
                    selector: (row) => row.Reason || "-",
                    sortable: false,
                  },
                  {
                    name: "Status",
                    selector: (row) =>
                      row.Status === 1 ? "Approved" : "Not Approved",
                    sortable: true,
                  },
                ]}
                data={filteredLeaveData}
                pagination
              />
            </>
          )}
        </div>

        {!loading && AttendenceRecords.length > 0 ? (
          <div className="w-full justify-end flex">
            <button
              onClick={handleApprove}
              type="button"
              className="btn btn-primary"
              disabled={
                !date ||
                date >= today ||
                filteredRows.length === 0 ||
                filteredRows.some(
                  (el) => formatDateOnly(el.RECORDDATE) !== date,
                )
              }
            >
              Approve attendance
            </button>
          </div>
        ) : null}
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-[3px] z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-96">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Do you want to cancel the approve?
              </h2>
              <div className="flex justify-end gap-4">
                <button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md px-4 py-2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="bg-red-500 hover:bg-red-600 text-white rounded-md px-4 py-2"
                  onClick={handleConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
